import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { mutationFn, type NarrativeCreationResponseData } from './mutationFn';

type Options = {
  onSuccess?: (data: NarrativeCreationResponseData) => void;
};

export const getQueryKey = (
  companyId: string,
  userId: string
): [string, string, string] => ['NARRATIVES', companyId.toLowerCase(), userId];

export const useCreateNarrative = (options: Options = {}) => {
  const { addSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: mutationFn,
    onSuccess: (data: NarrativeCreationResponseData) => {
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Narrative successfully created',
      });
      options.onSuccess?.(data);
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to create narrative',
      });
    },
  });
};
